import { Card } from '@mui/material';
import React from 'react';

/**
 * The properties for the management view card
 */
interface AdminViewCardProps {
  /**
   * The element(s) to show within the card's card content
   */
  children: React.JSX.Element | React.JSX.Element[];
}

/**
 * The management view card
 */
const AdminViewCard = (props: AdminViewCardProps) => {
  const cardHeight = '100%';

  return (
    <Card elevation={5} sx={{ height: cardHeight }}>
      {props.children}
    </Card>
  );
};

export default AdminViewCard;
